<template>
  <div class="module-rules__caption">Updates:</div>
  <TaggingRulesActionsItem
    v-for="name in actionsList"
    :key="name"
    v-model="actionsModel"
    :name
    :disabled
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { TaggingRuleAction } from './utils/types'
import { TaggingRuleActionType } from './utils/enums'

import TaggingRulesActionsItem from './TaggingRulesActionsItem.vue'

type Props = {
  disabled?: boolean
}

defineProps<Props>()

const actionsModel = defineModel<TaggingRuleAction[]>()

const actionsList = computed(() => Object.values(TaggingRuleActionType))
</script>
